import React, { useContext, useMemo } from 'react';
import { SnackbarProvider, useSnackbar as useNoistackSnackbar } from 'notistack';
import CloseIcon from '@pixel/assets/icons/Close';
import StatusMessage from '../StatusMessage';
import SnackbarContent from '../SnackbarContent';
import IconButton from '../IconButton';
import { useTheme } from "../styles";
export let SnackbarVariants = /*#__PURE__*/function (SnackbarVariants) {
  SnackbarVariants["success"] = "success";
  SnackbarVariants["info"] = "info";
  SnackbarVariants["warning"] = "warning";
  SnackbarVariants["error"] = "error";
  return SnackbarVariants;
}({});
const SnackbarServiceContext = /*#__PURE__*/React.createContext(null);
export const useSnackbar = () => useContext(SnackbarServiceContext);
const SnackbarServiceSubProvider = _ref => {
  let {
    children,
    onBeforeSnackbarShow
  } = _ref;
  const {
    enqueueSnackbar,
    closeSnackbar
  } = useNoistackSnackbar();

  // set position based on theme
  const theme = useTheme();
  const position = theme.direction == "rtl" ? "right" : "left";
  const anchorOrigin = {
    vertical: "bottom",
    horizontal: position
  };
  const showVariant = function (text) {
    let timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5000;
    let variant = arguments.length > 2 ? arguments[2] : undefined;
    let proccessContinue = true;
    if (typeof onBeforeSnackbarShow == "function") {
      proccessContinue = onBeforeSnackbarShow({
        text,
        timeout,
        variant
      }) === false ? false : true; //directly check this for false if the ats returns false only then dont continue (if they forget to return or return anything else then continue)
    }
    console.log("proccessContinue", proccessContinue);
    if (proccessContinue) {
      const snackMessage = {
        message: /*#__PURE__*/React.createElement(StatusMessage, {
          type: variant
        }, "\xA0\xA0", text),
        variant,
        handleClose: closeSnackbar
      };
      enqueueSnackbar(
      // @ts-ignore because we are using a custom message that the service passes but doesnt type
      snackMessage, {
        autoHideDuration: timeout,
        anchorOrigin
      });
    }
  };
  const snackContext = useMemo(() => ({
    showInfo: (text, timeout) => {
      showVariant(text, timeout, SnackbarVariants.info);
    },
    showWarning: (text, timeout) => {
      showVariant(text, timeout, SnackbarVariants.warning);
    },
    showError: (text, timeout) => {
      showVariant(text, timeout, SnackbarVariants.error);
    },
    showSuccess: (text, timeout) => {
      showVariant(text, timeout, SnackbarVariants.success);
    }
  }), []);
  return /*#__PURE__*/React.createElement(SnackbarServiceContext.Provider, {
    value: snackContext
  }, children);
};
export const SnackbarServiceProvider = _ref2 => {
  let {
    closeLabel = "Close",
    children,
    maxSnack,
    onBeforeSnackbarShow
  } = _ref2;
  return /*#__PURE__*/React.createElement(SnackbarProvider, {
    maxSnack: maxSnack
    // @ts-ignore
    ,
    content: (key, snackMessage) => {
      const {
        variant,
        message,
        handleClose
      } = snackMessage;
      return /*#__PURE__*/React.createElement(SnackbarContent, {
        key: key,
        message: message,
        action: [/*#__PURE__*/React.createElement(IconButton, {
          key: "close",
          color: "inherit",
          onClick: () => handleClose(key),
          "aria-label": closeLabel
        }, /*#__PURE__*/React.createElement(CloseIcon, null))],
        sx: {
          backgroundColor: "".concat(variant, ".snackbarBackground"),
          color: "".concat(variant, ".dark")
        }
      });
    }
  }, /*#__PURE__*/React.createElement(SnackbarServiceSubProvider, {
    onBeforeSnackbarShow: onBeforeSnackbarShow
  }, children));
};
export default SnackbarServiceProvider;